import type { SupabaseClient } from '@supabase/supabase-js';

/** True when a 401 may be a cross-tab refresh-token race (valid cookie session still present), not a genuine denial. */
export const hasRecoverableSession = async (supabase: SupabaseClient): Promise<boolean> => {
  try {
    const { data, error } = await supabase.auth.getSession();
    return !error && data.session !== null;
  } catch {
    return false;
  }
};
